/* global Ably */
define('drfront-experiment-tracker',[
    'jquery',
    'underscore',
    'event-manager',
    'pulse',
    'track-visibility',
    'hijack-click'
], function(
    $,
    _,
    eventManager,
    Pulse,
    trackVisibility,
    hijackClick
) {

    'use strict';

    /**
     * Ably in 'drfront' namespace
     *
     * @type {Ably}
     */
    var ably;

    /**
     * Get active DrFront experiments
     *
     * @return {
     *         Objext.<string, {
     *             elements: Object.<string, HTMLElement>,
     *             weights: Object.<string, Number>
     *         }>
     * } Data about experiments
     */
    function getExperiments() {
        var experiments = {};

        $('[data-experiment-id]').each(function() {
            if (!this.dataset) {
                return;
            }

            var experimentId = this.dataset.experimentId,
                variantId = this.dataset.variantId;

            if (experiments[experimentId] === undefined) {
                experiments[experimentId] = {
                    elements: {},
                    weights: {}
                };
            }

            if (experiments[experimentId].elements[variantId] === undefined) {
                experiments[experimentId].elements[variantId] = this;
            }

            if (experiments[experimentId].weights[variantId] === undefined) {
                experiments[experimentId].weights[variantId] = 1;
            }
        });

        return experiments;
    }

    /**
     * Register given experiments in Ably.
     *
     * @param  {Objext.<string, {
     *             elements: Object.<string, HTMLElement>,
     *             weights: Object.<string, Number>
     *         }>} experiments Experiments to register
     */
    function registerExperiments(experiments) {
        _.each(experiments, function(variants, id) {
            ably.addTests([
                {
                    name: id,
                    sampler: ably.samplers.default(variants.weights),
                    scope: 'device'
                }
            ]);
        });
    }

    /**
     * Track an impression of a given experiment id.
     *
     * @param  {String}   experimentId An experiment id to track impression of
     * @param  {Function} callback     Callback to call when done
     */
    function trackImpression(experimentId, callback) {
        Pulse.ready(function(tracker) {
            tracker.track('trackerEvent', {
                type: 'View',
                object: {
                    type: 'UIElement',
                    '@id': ['sdrn:e24:frontpage:front:element', experimentId].join(':'),
                },
                provider: {
                    type: "Organization",
                    id: "e24",
                    'spt:engage': "e24",
                    productTag: 'e24'
                },
            }).then(function(res) { callback(!res || !res[0].ok); });
        });
    }

    /**
     * Install click tracking on a given element.
     *
     * @param  {HTMLElement}    element Element to install click tracking on
     * @param  {String}         experimentId Experiment id to report to trackin
     *                                       server
     * @return {Function}       Undo function. Call to deactivate click tracking.
     */
    function installClickTracking(element, experimentId) {
        function handleClick(done) {
            Pulse.ready(function(tracker) {
                tracker.track('trackerEvent', {
                    action: 'Click',
                    type: 'Click',
                    object: {
                        type: 'UIElement',
                        '@id': ['sdrn:e24:content:front:element', experimentId].join(':'),
                        name: 'DrFront experiment click',
                    },
                    provider: {
                        type: "Organization",
                        id: "e24",
                        'spt:engage': "e24",
                        productTag: 'e24'
                    },
                }).then(function() {
                    done();
                });
            });
        }

        return hijackClick(element, handleClick, 500);
    }

    /**
     * Track given experiments.
     *
     * @param  {{Object.<string, {
     *             elements: Object.<string, HTMLElement>,
     *             weights: Object.<string, Number>
     *         }>}} experiments Experiments to track
     */
    function trackExperiments(experiments) {
        _.each(experiments, function(variants, id) {
            ably.on(id, function(test) {
                var activeVariant = test.getAssignment();
                var activeElement = variants.elements[activeVariant];
                var experimentId = 'experiment:drfront:' + id + ':' + activeVariant;
                var trackedElements = [];

                if (activeElement) {
                    var deactivateVisibilityTracking = trackVisibility([activeElement], function (item) {
                        if (item.visible && trackedElements.indexOf(activeElement) === -1) {
                            trackedElements.push(activeElement);

                            var uninstallClickTracking = installClickTracking(activeElement, experimentId);
                            trackImpression(experimentId, function(err) {
                                if (err) {
                                    uninstallClickTracking();
                                }
                            });

                            deactivateVisibilityTracking();
                        }
                    }, 0);
                }
            });
        });
    }

    var init = function() {
        var experiments = getExperiments();

        if (_.isEmpty(experiments)) {
            return;
        }

        ably = new Ably('drfront');
        registerExperiments(experiments);
        trackExperiments(experiments);
    };

    return init;
});

